/**
 * Cinematic stock imagery + video (Pexels, free license — no attribution
 * required). These load directly from the Pexels CDN, which permits hotlinking.
 * To self-host, download each URL into public/cine/ and swap the paths.
 *
 * Pexels CDN patterns:
 *   photo: https://images.pexels.com/photos/<id>/pexels-photo-<id>.jpeg
 *   video: https://videos.pexels.com/video-files/<id>/<id>-hd_<w>_<h>_<fps>fps.mp4
 */

const px = (id: number, w = 1600): string =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

// Full-bleed hero — warm social gathering, faces, cinematic bokeh (video poster).
export const HERO_IMG = px(9124757, 1920);
// Hero video — a rooftop party, friends dancing / hanging out.
export const HERO_VIDEO =
  'https://videos.pexels.com/video-files/5935454/5935454-hd_1920_1080_25fps.mp4';

// Full-bleed band — concert crowd bathed in violet stage light (video poster).
export const BAND_IMG = px(3165492, 1920);
// Band video — people having fun at a concert.
export const BAND_VIDEO =
  'https://videos.pexels.com/video-files/2022396/2022396-hd_1920_1080_30fps.mp4';

// Scattered parallax collage — a mix of gatherings, nightlife and crowds.
export const COLLAGE: { id: number; src: string }[] = [
  9124757, 5191739, 19674069, 30215324, 5156686, 5970895, 7180617, 5638833,
  13230484, 6224614,
].map((id) => ({ id, src: px(id, 900) }));

// Real event/post covers from Gather's R2 bucket (used in the feature previews).
const R2 = 'https://pub-b30094e308754d8a889be5a6fd111a5c.r2.dev/covers/';
export const COVERS = {
  ghosts: `${R2}81008143-ce6a-4e23-b0e0-04a02ec98faa.jpeg`,
  jukebox: `${R2}0f15b755-66c2-433e-bd3e-65ec57f25f4f.jpg`,
  sunset: `${R2}153bab05-433e-443c-807c-c6a0c3d11d8f.jpg`,
  diner: `${R2}236bdeb1-e0f3-4b16-ba20-57e24519a3e4.jpg`,
  car: `${R2}436dd905-879e-415a-a223-630394e54f04.jpg`,
  cat: `${R2}7cf0f803-d17a-46e8-9d9b-bc80f8eaf43e.jpg`,
  palms: `${R2}9c103e23-9bcb-4631-ac40-e3daa1ce5626.jpg`,
  beach: `${R2}a6c04554-bc54-4ba3-a2c3-9db156a59c08.jpg`,
};
